import { Button } from '@mui/material';
import styled from 'styled-components';
export const HeaderSecondary = styled.div ``;
export const Wrapper = styled.div ``;
export const StyledButton = styled(Button) `
	text-transform: none;
`;
